<div class="oc-section-header">
  <span>CARTERAS MODELO</span>
</div>
<div class="suscripcion-badge" *ngIf="fechaHoraSuscripcion" [title]="'Filtrando operaciones desde la fecha de suscripción: ' + fechaHoraSuscripcion">
  <mat-icon>schedule</mat-icon><span class="suscripcion-badge__text">Suscripción {{ fechaHoraSuscripcion }}</span>
</div>

<cdk-virtual-scroll-viewport [appendOnly]="false" [tvsItemSize]="24" [headerHeight]="34" #viewportValLat
  id="viewportValLat" class="wrapper2 mat-elevation-z2">
  <span *ngIf="loadinglistamodelo" class="spinner-border spinner-border-sm mr-2"></span>

  <table cdk-table [dataSource]="listModelo" class="table-striped tableStyle">
    <ng-container cdkColumnDef="fecharegistro">
      <th cdk-header-cell *cdkHeaderCellDef style="width:100px;" class="sticky-header"
          (click)="sortBy('fecharegistro')" [class.sorted]="sortState.active === 'fecharegistro'">
        Fecha registro
        <mat-icon class="sort-icon" *ngIf="sortState.active === 'fecharegistro'">
          {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
        </mat-icon>
      </th>
      <td cdk-cell *cdkCellDef="let element" style="width:100px; text-align:center;">
        {{ element.fecharegistro | date:'dd/MM/yyyy' }}
      </td>
    </ng-container>
    <ng-container cdkColumnDef="nombre">
      <th cdk-header-cell *cdkHeaderCellDef style="width:calc(100% - 254px);" class="sticky-header"
          (click)="sortBy('nombre')" [class.sorted]="sortState.active === 'nombre'">
        Modelo
        <mat-icon class="sort-icon" *ngIf="sortState.active === 'nombre'">
          {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
        </mat-icon>
      </th>
      <td cdk-cell *cdkCellDef="let element" class="nombre-cell" style="width:calc(100% - 254px); overflow:hidden;" [matTooltip]="element.nombre">
        <div class="nombre-content">

          <span
            *ngIf="element.bajista !== undefined"
            class="trend-icon"
            [class.trend-down]="element.bajista"
            [class.trend-up]="!element.bajista"
            [matTooltip]="element.bajista ? 'Bajista' : 'Alcista'">{{ element.bajista ? '↓' : '↑' }}</span>
            <span class="nombre-text">
            <a href="models?id={{element.idModelo}}&idcarteraoptima={{element.idcarteraoptima}}" target="_blank">{{ element.nombre.length > 18 ? (element.nombre | slice:0:18) + '…' : element.nombre }}</a>
          </span>
          <button class="delete-btn" (click)="eliminarCartera(element)" matTooltip="Eliminar cartera" [matTooltipShowDelay]="600">
            <mat-icon>delete</mat-icon>
          </button>
        </div>
      </td>
    </ng-container>
    <ng-container cdkColumnDef="periodo">
      <th cdk-header-cell *cdkHeaderCellDef style="width:110px; text-align:right;" class="sticky-header"
          (click)="sortBy('periodo')" [class.sorted]="sortState.active === 'periodo'">
        Periodo
        <mat-icon class="sort-icon" *ngIf="sortState.active === 'periodo'">
          {{ sortState.direction === 'asc' ? 'arrow_upward' : (sortState.direction === 'desc' ? 'arrow_downward' : '') }}
        </mat-icon>
      </th>
      <td cdk-cell *cdkCellDef="let element" style="width:110px; text-align:right; padding-right:6px;">
        <span class="meta-api-tag"><ng-container *ngIf="element.metaapi">MetaApi </ng-container>{{ formatPeriodo(element.periodo) }}</span>
      </td>
    </ng-container>
    <ng-container cdkColumnDef="checkbox">
      <th cdk-header-cell *cdkHeaderCellDef style="width:44px;"></th>
      <td cdk-cell *cdkCellDef="let row" style="width:44px; text-align:center; padding: 0 8px;">
        <mat-checkbox class="compact-checkbox" [disabled]="isLoading || isDisabledByMetaapi(row)" (change)="onRowCheckboxChange(row)"
          [checked]="isIdSelected(row.idcartera)"></mat-checkbox>
      </td>
    </ng-container>

    <tr cdk-header-row *cdkHeaderRowDef="displayedColumns"></tr>
    <tr cdk-row *cdkRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</cdk-virtual-scroll-viewport>